import { cn } from '@/lib/utils';

const positionColors: Record<string, string> = {
  C: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  '1B': 'bg-green-500/20 text-green-400 border-green-500/30',
  '2B': 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  '3B': 'bg-red-500/20 text-red-400 border-red-500/30',
  SS: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  LF: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  CF: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  RF: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  OF: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  DH: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  SP: 'bg-red-500/20 text-red-400 border-red-500/30',
  RP: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  P: 'bg-red-500/20 text-red-400 border-red-500/30',
  // NFL fallbacks
  QB: 'bg-red-500/20 text-red-400 border-red-500/30',
  RB: 'bg-green-500/20 text-green-400 border-green-500/30',
  WR: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  TE: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  K: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  DEF: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
};

export { positionColors };

interface MLBPlayerAvatarProps {
  name: string;
  headshotUrl?: string | null;
  position?: string;
  /** Tailwind size class for w/h, default "w-8 h-8" */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'w-6 h-6 text-[8px]',
  md: 'w-8 h-8 text-[10px]',
  lg: 'w-10 h-10 text-xs',
};

const MLBPlayerAvatar = ({ name, headshotUrl, position, size = 'md', className }: MLBPlayerAvatarProps) => {
  const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2);
  const sizeClasses = sizeMap[size];
  const bgColor = position && positionColors[position]
    ? positionColors[position].split(' ')[0] // just bg class
    : 'bg-muted';

  if (headshotUrl) {
    return (
      <img
        src={headshotUrl}
        alt={name}
        className={cn(sizeClasses, "rounded-full bg-muted object-cover shrink-0", className)}
        onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
      />
    );
  }

  return (
    <div className={cn(sizeClasses, "rounded-full bg-muted flex items-center justify-center shrink-0", className)}>
      <span className="font-bold text-muted-foreground">{initials}</span>
    </div>
  );
};

export default MLBPlayerAvatar;
